import { render } from "./indexProposalComponent.vue?vue&type=template&id=c7f62e34&scoped=true"
import script from "./indexProposalComponent.vue?vue&type=script&lang=js"
export * from "./indexProposalComponent.vue?vue&type=script&lang=js"

import "./indexProposalComponent.vue?vue&type=style&index=0&id=c7f62e34&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/r2-disponibilidade-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7f62e34"]])

export default __exports__